import React from 'react';
import ConfirmDialog from '@/commons/confirm-dialog/ConfirmDialog';
import FormProvider from '@/commons/hook-form/FormProvider';
import { useForm } from 'react-hook-form';
import { Button } from '@mui/material';
import { translates } from '@/utils';
import { yupResolver } from '@hookform/resolvers/yup';
import { OrdersDetail } from '../../types';
import { DiscountFormFields } from './fields';
import { discountSchema } from './validations';
import { LoadingButton } from '@mui/lab';

interface Props {
  open: boolean;
  onClose: () => void;
  initialData: OrdersDetail[];
  onSubmit: (values: SubmitDataFormat) => Promise<void>;
  isLoading: boolean;
}

type SubmitDataFormat = {
  ordersDetails: Pick<OrdersDetail, 'id' | 'quantity_discount' | 'discount'>[];
};

export type FormFields = {
  ordersDetails: OrdersDetail[];
};

export const DiscountForm = ({ open, onClose, initialData, onSubmit,isLoading }: Props) => {
  const form = useForm<FormFields>({
    defaultValues: {
      ordersDetails: initialData.map((orderDetail : any) => {
        const {product,...rest}= orderDetail;

        return {
          ...rest,
          product: product.product
        }

      }),
    },
    resolver: yupResolver(discountSchema),
  });

  const handleSubmit = async ({ ordersDetails }: FormFields) => {
    const dataMapped = {
      ordersDetails: ordersDetails.map(({ id, quantity_discount, discount }) => ({
        id,
        quantity_discount,
        discount,
      })),
    };

    await onSubmit(dataMapped);
  };

  return (
    <FormProvider methods={form} onSubmit={form.handleSubmit(handleSubmit)}>
      <ConfirmDialog
        open={open}
        onClose={onClose}
        action={
          <LoadingButton loading={isLoading}  type="button" onClick={form.handleSubmit(handleSubmit)}>
            {translates.saveChanges}
          </LoadingButton>
        }
        title={translates.add_discount}
        content={<DiscountFormFields control={form.control} />}
      />
    </FormProvider>
  );
};
